module.exports = {
    Boot: require('./Boot'),
    Game: require('./Game'),
    Menu: require('./Menu'),
};



// WEBPACK FOOTER //
// ./src/State/index.js